export interface WeaponDefinition {
  id: 'rivet_caster' | 'arc_shove' | 'wrecking_bar';
  label: string;
  role: string;
  color: number;
  accent: string;
  cooldown: number;
}

export const weaponDefinitions: Record<WeaponDefinition['id'], WeaponDefinition> = {
  rivet_caster: {
    id: 'rivet_caster',
    label: 'RIVET CASTER',
    role: 'PRECISION // 22 DAMAGE',
    color: 0x60e8d2,
    accent: '#68dfcc',
    cooldown: 0.28,
  },
  arc_shove: {
    id: 'arc_shove',
    label: 'ARC SHOVE',
    role: 'CLOSE // HEAVY KNOCKBACK',
    color: 0xff7b35,
    accent: '#ff8a45',
    cooldown: 0.72,
  },
  wrecking_bar: {
    id: 'wrecking_bar',
    label: 'WRECKING BAR',
    role: 'MELEE // BRUTAL KNOCKBACK',
    color: 0xffc34d,
    accent: '#ffd26f',
    cooldown: 0.58,
  },
};
